module.exports = __webpack_public_path__ + "img/logo-oah.344c265b.svg";